import { BlockingReasonVariant } from './_types';

type BlockingReasonType = 'paymentRequired' | 'waiverRequired' | 'custom';

type BlockingReasonField = 'title' | 'titleNoAmount' | 'message';

export function blockingReasonTranslationKey(
  variant: BlockingReasonVariant,
  reason: BlockingReasonType,
  field: BlockingReasonField
): string {
  if (variant === 'booking') {
    return `blockingReasons.booking.${reason}.${field}`;
  }

  return `blockingReasons.${reason}.${field}`;
}
